import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {PriceReductionComponent} from '../price-reduction.component';
import {NotificationType} from '~core/enum/notification.enum';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {Lottery} from '~core/models';
import {PriceReduction} from '~core/models/tixx-select/price-reduction';
import {AttributeService, DefaultNotificationService, StorageService} from '~core/services';
import {PriceReductionService} from '~core/services/tixx-select/price-reduction.service';
import {ProcessConfigurationService} from '~core/services/tixx-select/process-configuration.service';
import {TixxSelectTranslationsService} from '~shared/translations/alerts/tixx-select-overview-translations.service';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

@UntilDestroy()
@Component({
  selector: 'app-price-reduction-create',
  templateUrl: '../price-reduction.component.html'
})

export class PriceReductionCreateComponent extends PriceReductionComponent implements OnInit {
  @Input() selectedLottery: Lottery;

  constructor(
    private formBuilder: UntypedFormBuilder,
    protected processConfigurationService: ProcessConfigurationService,
    protected attributeService: AttributeService,
    protected storageService: StorageService,
    private notificationService: DefaultNotificationService,
    protected priceReductionService: PriceReductionService,
    public tixxSelectOverviewService: EventAdministrationService,
    public tixxSelectTranslationService: TixxSelectTranslationsService,
    public flTranslations: FormLabelTranslationService,
    public buttonsTranslations: ButtonsTranslations,
    public spinnerService: SpinnerService,
  ) {
    super(processConfigurationService, attributeService, storageService, priceReductionService, tixxSelectOverviewService,
      tixxSelectTranslationService, flTranslations, buttonsTranslations, spinnerService);
  }

  ngOnInit(): void {
    this.i18nHeading = $localize`:@@tixxSelect.modalTitle.createPriceReduction:Create a price reduction`;
    this.spinnerName = 'createPriceReductionSubmit';
    this.fillForm();
  }

  get modalStatus(): boolean {
    return this.tixxSelectOverviewService.listOfModals.createPriceReductionsModalOpened;
  }

  /**
   * Create the form.
   */
  public fillForm(): void {
    this.priceReductionForm = this.formBuilder.group({
      submissionProcessSetup: [this.processConfiguration['@id']],
      name: ['', [Validators.required]],
      limitPerCustomerPresent: false,
      limitPerCustomer: [0],
      exclusiveForMembers: [false],
      clubAttributes: [[]]
    });
  }

  public formSubmit(form: UntypedFormGroup): void {
    const savedForm = form.value;

    if (form.valid) {
      delete savedForm.limitPerCustomerPresent;
      this.spinnerService.show(this.spinnerName);
      this.priceReductionService.create(savedForm).pipe(untilDestroyed(this))
        .subscribe({
          next: (res: PriceReduction) => {
            this.priceReductionService.addPriceReductionList(res);
            this.spinnerService.hide(this.spinnerName);
            this.tixxSelectOverviewService.toggleCreatePriceReductionsModal(false);
            this.notificationService.showNotification({
              type: NotificationType.SUCCESS,
              message: this.tixxSelectTranslationService.i18nSuccessUpdateLottery
            });
            this.fillForm();
          },
          error: (error: Error) => {
            this.notificationService.showNotification({
              type: NotificationType.ALERT,
              message: this.tixxSelectTranslationService.i18nErrorUpdateLottery
            });
            this.spinnerService.hide(this.spinnerName);
          }
        });
    }
  }
}
